import { gql } from "@apollo/client";

export const CREATE_PARTICIPANT = gql`
  mutation CreateParticipant($input: UpdateParticipantInput!) {
    createCertParticipant(input: $input) {
      id
    }
  }
`;

export const UPDATE_PARTICIPANT = gql`
  mutation UpdateParticipant($id: ID!, $input: UpdateParticipantInput!) {
    updateCertParticipant(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_PARTICIPANT = gql`
  mutation DeleteParticipant($id: ID!) {
    deleteCertParticipant(id: $id) {
      id
    }
  }
`;
